import VideoJS from './VideoJS';

// https://videojs.com/guides/react/

const HeroVideo = ({ video, poster }) => {

  const videoJsOptions = {
    autoplay: true,
    muted: true,
    loop: true,
    controls: true,
    fluid: true,
    playsinline: true,
    // sources: [{
    //   src: `${process.env.RAZZLE_CDN}/video/audi-e-tron-trimmed.mp4`,
    //   type: 'video/mp4'
    // }],
    sources: [{
      src: video,
      type: 'video/mp4'
    }],
    poster: poster
  };

  return (
    <VideoJS className="drawHeroVideo" options={videoJsOptions} onReady={(player) => {
      // playerRef.current = player;
    }} />
  );
}

export default HeroVideo;
